export default __webpack_public_path__ + "static/media/ArrowRight.059c1052.svg";